export interface IErrorMessage {
  message: string;
  data?: object;
}

export class ErrorMessage implements IErrorMessage {
  constructor(public message: string, public data?: object){}
}
